export enum SearchResultTypes {
  'APPLICATION' = 1,
  'JOB' = 2,
  'VIEW' = 3,
}
